import React from 'react';

import { useGetMedicationStatement } from '@hooks/api/medication';
import { useCuration } from '@hooks/useCuration';
import { useSession } from '@hooks/useSession';

import Content from './Content';

const Medication: React.FC<{ id?: string }> = ({ id = '' }) => {
  const { data, loading } = useGetMedicationStatement({
    record_id: id,
  });

  const {
    state: { activeProfile, isCurator, isPatient },
  } = useSession();
  const [patient_id] = [activeProfile?.patient_id];
  const {
    state: { isCreating, isEditing },
    finishAddingRecord,
    stopEditingRecord,
  } = useCuration();

  const handleSubmit = () => {
    stopEditingRecord();
    finishAddingRecord();
  };

  return (
    <Content
      data={data}
      isCreating={isCreating}
      isCurator={isCurator}
      isEditing={isEditing}
      isPatient={isPatient}
      loading={loading}
      onSubmit={handleSubmit}
      patientId={patient_id}
    />
  );
};

export default Medication;
